import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=42bb925c&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb925c",
  null
  
)

export default component.exports